export const categories = [
    { value: "all", label: "All" },
    { value: "art", label: "Art" },
    { value: "biography", label: "Biography" },
    { value: "computers", label: "Computers" },
    { value: "history", label: "History" },
    { value: "medical", label: "Medical" },
    { value: "poetry", label: "Poetry" }
];

export const sortingOptions = [
    { value: "relevance", label: "Relevance" },
    { value: "newest", label: "Newest" }
];
